package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.MediaOutline: ImageVector
    get() {
        if (_mediaOutline != null) {
            return _mediaOutline!!
        }
        _mediaOutline = Builder(name = "MediaOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 15.0f, viewportHeight = 15.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(3.3558f, 5.9134f)
                lineTo(6.9615f, 0.0f)
                lineTo(10.5672f, 5.9134f)
                lineTo(3.3558f, 5.9134f)
                lineTo(3.3558f, 5.9134f)
                moveTo(11.0865f, 14.1634f)
                curveTo(10.226f, 14.1634f, 9.4964f, 13.8641f, 8.8978f, 13.2656f)
                curveTo(8.2993f, 12.667f, 8.0f, 11.9375f, 8.0f, 11.0769f)
                curveTo(8.0f, 10.2163f, 8.2993f, 9.4867f, 8.8978f, 8.8882f)
                curveTo(9.4964f, 8.2896f, 10.226f, 7.9904f, 11.0865f, 7.9904f)
                curveTo(11.9471f, 7.9904f, 12.6767f, 8.2896f, 13.2752f, 8.8882f)
                curveTo(13.8738f, 9.4867f, 14.173f, 10.2163f, 14.173f, 11.0769f)
                curveTo(14.173f, 11.9375f, 13.8738f, 12.667f, 13.2752f, 13.2656f)
                curveTo(12.6767f, 13.8641f, 11.9471f, 14.1634f, 11.0865f, 14.1634f)
                lineTo(11.0865f, 14.1634f)
                moveTo(0.5f, 13.7884f)
                lineTo(0.5f, 8.3654f)
                lineTo(5.923f, 8.3654f)
                lineTo(5.923f, 13.7884f)
                lineTo(0.5f, 13.7884f)
                lineTo(0.5f, 13.7884f)
                moveTo(11.0863f, 13.0384f)
                curveTo(11.6355f, 13.0384f, 12.0997f, 12.8488f, 12.4791f, 12.4696f)
                curveTo(12.8584f, 12.0904f, 13.0481f, 11.6263f, 13.0481f, 11.0771f)
                curveTo(13.0481f, 10.5279f, 12.8585f, 10.0637f, 12.4793f, 9.6843f)
                curveTo(12.1001f, 9.305f, 11.6359f, 9.1153f, 11.0867f, 9.1153f)
                curveTo(10.5375f, 9.1153f, 10.0733f, 9.3049f, 9.694f, 9.6841f)
                curveTo(9.3146f, 10.0633f, 9.125f, 10.5275f, 9.125f, 11.0767f)
                curveTo(9.125f, 11.6259f, 9.3146f, 12.0901f, 9.6938f, 12.4694f)
                curveTo(10.073f, 12.8488f, 10.5371f, 13.0384f, 11.0863f, 13.0384f)
                lineTo(11.0863f, 13.0384f)
                moveTo(1.625f, 12.6634f)
                lineTo(4.7981f, 12.6634f)
                lineTo(4.7981f, 9.4903f)
                lineTo(1.625f, 9.4903f)
                lineTo(1.625f, 12.6634f)
                lineTo(1.625f, 12.6634f)
                moveTo(5.3404f, 4.7884f)
                lineTo(8.5827f, 4.7884f)
                lineTo(6.9615f, 2.1807f)
                lineTo(5.3404f, 4.7884f)
                lineTo(5.3404f, 4.7884f)
                moveTo(6.9615f, 4.7884f)
                lineTo(6.9615f, 4.7884f)
                lineTo(6.9615f, 4.7884f)
                lineTo(6.9615f, 4.7884f)
                lineTo(6.9615f, 4.7884f)
                moveTo(4.7981f, 9.4903f)
                lineTo(4.7981f, 9.4903f)
                lineTo(4.7981f, 9.4903f)
                lineTo(4.7981f, 9.4903f)
                lineTo(4.7981f, 9.4903f)
                lineTo(4.7981f, 9.4903f)
                moveTo(11.0865f, 11.0769f)
                lineTo(11.0865f, 11.0769f)
                lineTo(11.0865f, 11.0769f)
                lineTo(11.0865f, 11.0769f)
                lineTo(11.0865f, 11.0769f)
                lineTo(11.0865f, 11.0769f)
                lineTo(11.0865f, 11.0769f)
                lineTo(11.0865f, 11.0769f)
                lineTo(11.0865f, 11.0769f)
                lineTo(11.0865f, 11.0769f)
            }
        }
        .build()
        return _mediaOutline!!
    }

private var _mediaOutline: ImageVector? = null
